import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { ProductChange } from '../../model/product-change';
import { SessionStorageService } from '../../services/session-storage.service';


@Component({
    selector: 'pme-product-change',
    templateUrl: './product-change.component.html',
    styleUrls: ['./product-change.component.scss'],
    standalone: false
})
export class ProductChangeComponent implements OnInit {
    @Input() productData: ProductChange;
    @Input() redirectUrl: string;
    @Input() returnUrl: string;
    isCollapsed: boolean = true;
    visibleItems: number = 3;
   
  // Adicione ViewChild
  @ViewChild('showMore', { read: TemplateRef }) showMoreTemplate: TemplateRef<any>;
  
  
  constructor(public router: Router, private sessionStorageService: SessionStorageService) {
    this.sessionStorageService = sessionStorageService;
    this.isCollapsed = true;
   }

  ngOnInit(): void {
    
    if(this.productData){
      this.visibleItems = this.productData.currentPlan ? 3 : this.productData.featureList.length;
    }
  }
  
  navigate() {
    if (this.productData.currentPlan) {
      return;
    }


    const queryParams = {
      newPlan: this.productData.planIdentifier,
      businessId: this.sessionStorageService.getBusinessId(),
      userId: this.sessionStorageService.getUserId(),
      redirectUrl: this.redirectUrl,
      returnUrl: this.returnUrl
    };

    // Use a rota absoluta começando com '/'
    const url = '/auto-atendimento/'+this.sessionStorageService.getClassification()+'/upgrade';

    this.router.navigate([url], { queryParams });
  }

  toggleCollapse() {
    this.isCollapsed = !this.isCollapsed;
    this.visibleItems = ! this.isCollapsed ? this.productData.featureList.length : 3;
  }
}
